import React, { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { App as CapApp } from '@capacitor/app';
import { PageHeader, Card, Row, Heading } from '@/components/rc';
import AccountSection from '@/components/settings/AccountSection';
import PlanSection from '@/components/settings/PlanSection';
import PreferencesSection from '@/components/settings/PreferencesSection';
import DangerZoneSection from '@/components/settings/DangerZoneSection';
import { openExternal } from '@/utils/openExternal';

// ── Constants ──

const PRIVACY_URL = 'https://ravecave.app/privacy';
const TERMS_URL = 'https://ravecave.app/terms';

// ── Settings Page ──

const SettingsPage: React.FC = () => {
  // Was hardcoded "1.0.0", which had drifted from the shipping build. Native
  // reports the real package version and build number; web falls back to the
  // version injected from package.json at build time.
  const [version, setVersion] = useState<string>(__APP_VERSION__);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;
    CapApp.getInfo()
      .then(info => setVersion(`${info.version} (${info.build})`))
      .catch(() => {});
  }, []);

  return (
    <div className="p-4 sm:p-10 h-full overflow-y-auto overflow-x-hidden">
      <PageHeader title="SETTINGS" subtitle="Account & preferences" />
      <div className="h-8" />

      <AccountSection />
      <div className="h-8" />

      <PlanSection />
      <div className="h-8" />

      <PreferencesSection />
      <div className="h-8" />

      {/* ── About Section ── */}
      <Heading scale="subhead" className="mb-2">About</Heading>
      <Card elevation="flat">
        <Row title="Version" trailingAction="value" trailingValue={version} divider={true} />
        <Row
          title="Privacy Policy"
          trailingAction="chevron"
          onClick={() => openExternal(PRIVACY_URL)}
          divider={true}
        />
        <Row
          title="Terms of Service"
          trailingAction="chevron"
          onClick={() => openExternal(TERMS_URL)}
          divider={false}
        />
      </Card>
      <div className="h-8" />

      <DangerZoneSection />
      <div className="h-20" />
    </div>
  );
};

export default SettingsPage;
